import { useTranslation } from "react-i18next";

function ExistsClientList({ existsList }: { existsList: string[] }) {
    const { t } = useTranslation();
    if (existsList.length === 0) return null;
    return (
        <div
            className="my-1 flex max-w-full flex-col gap-2 rounded-md bg-blue-200 px-4 py-3 text-sm text-blue-700"
            role="alert"
        >
            <h3 className="font-semibold text-sm m-0">{t("clientImportModal.existingUsers") || "Existing Users"}</h3>
            <ul className="list-inside list-decimal space-y-1 break-words">
                {existsList.map((client, i) => (
                    <li key={i} className="max-w-full leading-snug">
                        {client}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ExistsClientList;
